require.register("ffss/component/row/ClubResult", function(exports, require, module){
  $0
  
});

